# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class ApplyLink extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'ApplyLinkModule'
#
#   @selector: ".apply_link_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# ApplyLink.register()
